import { Group, Text, Tooltip } from "@mantine/core";
import { pluralize } from "#app/utils/pluralize.ts";

export function StatLabel(props: {
  emoji: string;
  label: string;
  value: number;
  extraLabel?: string;
  showValue?: boolean;
}) {
  const { emoji, label, value, extraLabel = "", showValue = true } = props;

  return (
    <Tooltip label={`${value} ${pluralize(label, value)} ${extraLabel}`}>
      <Group gap={6} wrap="nowrap" style={{ cursor: "default" }}>
        <Text>{emoji}</Text>
        <Text size="sm" style={{ fontFamily: "monospace" }}>
          {showValue ? value : null}
        </Text>
      </Group>
    </Tooltip>
  );
}
